// extracted by mini-css-extract-plugin
export var fullGrid = "_2y-3";
export var pdpPreviewContainer = "_2y-1";
export var previewContainer = "_2y-0";
export var togglePreviewContainer = "_2y-2";